import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private contentSubject = new BehaviorSubject<any>(null);
  private contentInputsSubject = new BehaviorSubject<any>({});
  private contentOutputsSubject = new BehaviorSubject<any>({});

  content$ = this.contentSubject.asObservable();
  contentInputs$ = this.contentInputsSubject.asObservable();
  contentOutput$ = this.contentOutputsSubject.asObservable();

  setContent(content: any, inputs: any= {}) {
    this.contentSubject.next(content);
    this.contentInputsSubject.next(inputs);
  }
  setContentOutput(output: any) {
    this.contentOutputsSubject.next(output);
  }

}
